var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from "@angular/common/http";
import { CustomFilterService } from "path-shared/services/datasource/custom-filter-service";
var ZbHorariosFilterService = /** @class */ (function (_super) {
    __extends(ZbHorariosFilterService, _super);
    function ZbHorariosFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZbHorariosFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('somId', filter.somId ? filter.somId.toString() : '')
            .append('name', filter.nombre ? filter.nombre.toString() : '')
            .append('description', filter.descripcion ? filter.descripcion.toString() : '')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField)
            .append('sortdir', sortDir);
    };
    return ZbHorariosFilterService;
}(CustomFilterService));
export { ZbHorariosFilterService };
